import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import {V3ExamSession, V3ExerciseSession} from '../cspa/model/v3/cspa';

@Injectable({
  providedIn: 'root'
})

export class SessionInfo {
  questionNb: string
  session: V3ExerciseSession | V3ExamSession
  questionType?: string
  questionCount?: number
  progressPercent?: number
}

export class SessionInfoService {

  private sessionInfo = new ReplaySubject<SessionInfo>(1);

  constructor() { }

  setSessionInfo(progressInfo: SessionInfo): void{
    this.sessionInfo.next(progressInfo)
  }

  getSessionInfo(): Observable<SessionInfo>{
    return this.sessionInfo.asObservable()
  }
}
